import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";

type TierListSettings = {
  [key in QueueTypeS]?: {
    showAgainst?: boolean;
    showBan?: boolean;
    showPick?: boolean;
    showRole?: boolean;
    showTier?: boolean;
    showRoleQuest?: boolean;
  };
};

export const tierListSettings: TierListSettings = {
  [QueueTypeS.RANKED_SOLO]: {
    showAgainst: true,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.RANKED_FLEX]: {
    showAgainst: true,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.NORMAL_BLIND]: {
    showAgainst: false,
    showBan: false,
    showPick: false,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.QUICKPLAY]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.SWIFTPLAY]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.NORMAL_DRAFT]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: true,
  },
  [QueueTypeS.ARAM]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
    showRoleQuest: false,
  },
  [QueueTypeS.NEXUS_BLITZ]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
    showRoleQuest: false,
  },
  [QueueTypeS.URF]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
    showRoleQuest: false,
  },
  [QueueTypeS.ARURF]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
    showRoleQuest: false,
  },
  [QueueTypeS.ONE_FOR_ALL]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: false,
    showTier: true,
    showRoleQuest: false,
  },
};
